<template>
  <div v-if="files?.length" :class="[$style.root, viewOption === 'expanded' ? $style.expanded : null]">
    <div v-if="viewOption === 'default'">
      {{ $t('shared.downloads', { count: files?.length }) }}:
    </div>
    <template
      v-for="(file, index) in files"
      :key="file?.url"
    >
      <a
        :href="file?.url"
        target="_blank"
        :class="$style.fileUrl"
      >
        {{ truncate(file?.name, truncateNumber) }} ({{ file?.mime?.split('/')?.pop() }})
      </a>{{ index + 1 < files?.length && viewOption === 'default' ? ', ' : '' }}
    </template>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  downloads: Array,
  viewOption: {
    type: String,
    default: 'default',
    validator: (val) => ['default', 'expanded'].includes(val)
  }
})

const files = props?.downloads?.map(file => {
  const attributes = baseStrapiGetAttributes(file)
  return {
    ...attributes,
    url: baseStrapiGetAbsoluteFileUrl(attributes?.url, attributes?.provider)
  }
})?.filter(Boolean)

const truncateNumber = props?.viewOption === 'default' ? 10 : 100

const truncate = (str: string, length: number = 10) => {
  return str?.length > length ? str?.substring(0, length - 3) + '...' : str
}
</script>

<style module>
.root {
  composes: reset-list font-helvetica font-size-small from global;
}

.expanded {
  display: flex;
  flex-direction: column;
}

.fileUrl {
  composes: reset-link from global;
  display: inline-block;
}

.fileUrl[href]::first-letter {
  text-decoration-line: underline;
}

.fileUrl:hover {
  text-decoration-line: underline;
}
</style>
